import { h, defineComponent } from 'vue';
import { container, pageTitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import * as qs from '@/ui/queryState';
import { secondaryNavbar, TabItem } from '@/ui/components/navigation/SecondaryNavbar';
import { SubscriptionTabNames, queryTabName } from '@/ui/components/navigation/constants';

import PlanDetails from '@/_legacy/views/Subscriptions/PlanDetails.vue';
import BillingDetails from '@/_legacy/views/Subscriptions/BillingDetails.vue';
import Invoices from '@/_legacy/views/Subscriptions/Invoices.vue';
import SubscriptionLog from '@/_legacy/views/Subscriptions/SubscriptionLog.vue';

export const SubscriptionPage = defineComponent({
  name: 'SubscriptionPage',
  setup() {
    const activeTab = qs.stringEnum<SubscriptionTabNames>(
      queryTabName,
      Object.values(SubscriptionTabNames),
      SubscriptionTabNames.PLAN_DETAILS,
      false,
    );

    const secondaryTabItems : TabItem[] = [
      {
        value: SubscriptionTabNames.PLAN_DETAILS,
        label: t('Plan details'),
        icon: 'user',
        underLineColor: 'blue',
      },
      {
        value: SubscriptionTabNames.BILLING_DETAILS,
        label: t('Billing details'),
        icon: 'wallet',
        underLineColor: 'green',
      },
      {
        value: SubscriptionTabNames.INVOICES,
        label: t('Invoices'),
        icon: 'file-invoice',
        underLineColor: 'orange',
      },
      {
        value: SubscriptionTabNames.SUBSCRIPTION_LOG,
        label: t('Subscription logs'),
        icon: 'book',
        underLineColor: 'purple',
      },
    ];

    const getTab = () => {
      switch (activeTab.value) {
        case SubscriptionTabNames.PLAN_DETAILS:
          return PlanDetails;
        case SubscriptionTabNames.BILLING_DETAILS:
          return BillingDetails;
        case SubscriptionTabNames.INVOICES:
          return Invoices;
        case SubscriptionTabNames.SUBSCRIPTION_LOG:
          return SubscriptionLog;
        default:
          throw new Error('Invalid tab selected. Please use SubscriptionTabEnum enumeration');
      }
    };

    return function render() {
      return container(
        [
          pageTitle(t('common.subscriptions')),
          secondaryNavbar({
            props: { value: activeTab.value, tabItems: secondaryTabItems },
            on: {
              input: (value: SubscriptionTabNames) => {
                activeTab.value = value;
              },
            },
          }),
          h(getTab()),
        ],
        'narrow',
        'subscription-page',
      );
    };
  },
});
